export class GetFarmDapByFarmAndDAPUseCase {
  constructor(farmsDapRepository) {
    this.farmsDapRepository = farmsDapRepository;
  }

  async execute(ID_FARM,DAP) {
    const farm_dap = await this.farmsDapRepository.getByIdFarmAndDAP(ID_FARM,DAP)
    return farm_dap
  }
}
